<template>
  <div class="account__card  pt-3">
    <div class="account__border">
      <div class="account__card--topbar account__card--topbar--padding d-flex">
        <div class="text--green font-weight-bold">{{ $t(CustomValues[currentType].title) }}</div>
      </div>
    </div>

    <div class="account__border py-4">
      <div class="account--padding">
        <div class="row no-gutters">
          <input-text
              class="col-6 mb-3 pr-2"
              :title="$t('myAccount.firstName')"
              :data="v$.addressData.first_name"
              :error-text='$t("myAccount.errorFirstName")'
              name="firstname"
              :maxlength="32"
              id="input_first_name"
              v-model="addressData.first_name"
          />

          <input-text
              class="col-6 mb-3 pl-2"
              :maxlength="32"
              :title='$t("myAccount.lastName")'
              :data="v$.addressData.last_name"
              :error-text='$t("myAccount.errorLastName")'
              name="lastname"
              id="input_last_name"
              v-model="addressData.last_name"
          />

          <input-text
              class="mb-3"
              :class="parseInt(addressData.id_country) !== countriesData.ID_COUNTRY_FRANCE ? 'col-9 pr-2' : 'col-12'"
              :title='$t("myAccount.address")'
              :maxlength="32"
              :data="v$.addressData.address"
              :error-text='$t("myAccount.errorAddress")'
              :placeholder="$t('address.placeholderAddress')"
              :replace-item="true"
              name="address1"
              id="input_address"
              v-model="addressData.address"
          />

          <input-text
              v-if="parseInt(addressData.id_country) !== countriesData.ID_COUNTRY_FRANCE"
              :title='$t("myAccount.houseNumber")'
              class="col-3 mb-3 pl-2"
              :maxlength="5"
              :data="v$.addressData.house_number"
              placeholder="123 b"
              :replace-item="true"
              name="house_number"
              id="input_house_number"
              v-model="addressData.house_number"
          />

          <!-- Address 2 : BE, FR, DE, AT, IT -->
          <input-text
              v-if="addressTwoField.includes(parseInt(addressData.id_country))"
              class="col-12 mb-3"
              :title='$t("myAccount.address2")'
              :maxlength="32"
              :data="v$.addressData.address2"
              :error-text='$t("myAccount.errorAddress2")'
              :placeholder="$t('address.placeholderAddress2')"
              :optional='$t("myAccount.optional")'
              :replace-item="true"
              name="address2"
              id="input_address"
              v-model="addressData.address2"
          />

          <input-text
              v-on:input="removeSpaces"
              @keydown.space.prevent
              class="col-5 mb-3 pr-2"
              :title='$t("myAccount.zipcode")'
              :data="v$.addressData.postcode"
              :error-text='$t("myAccount.errorZipcode")'
              :placeholder="addressData.id_country === 19 ? '1234' : $t('address.placeholderZipcode')"
              name="postcode"
              :maxlength="6"
              id="input_postcode"
              v-model="addressData.postcode"
          />

          <input-text
              class="col-7 mb-3 pl-2"
              :title='$t("myAccount.residence")'
              :data="v$.addressData.city"
              :error-text='$t("myAccount.errorCity")'
              :placeholder="addressData.id_country === 19 ? 'Bern' : $t('address.placeholderCity')"
              name="city"
              :maxlength="32"
              id="input_city"
              v-model="addressData.city"
          />

          <div class="col-12 mb-3" v-show="((addressData.id_country === countriesData.ID_COUNTRY_NETHERLANDS && ! isGuest) || addressData.id_country === countriesData.ID_COUNTRY_FRANCE || addressData.id_country === countriesData.ID_COUNTRY_LUXEMBOURG)">
            <div>{{ $t("myAccount.country") }}</div>
            <select
                name="id_country"
                id="input_country_addressCreate"
                v-model="addressData.id_country"
                class="input-select--country"
                :value="addressData.id_country"
                v-on:change="checkCountry()"
            >
              <option
                  v-for="country in countries"
                  :value="parseInt(country.id_country)"
              >{{ country.name }}
              </option>
            </select>
          </div>

          <input-text
              v-if="currentType !== TYPE_CHECKOUT_ADDRESS"
              class="col-12 mb-3"
              :title='$t("myAccount.phoneNumber")'
              :data="v$.addressData.phone"
              :error-text='$t("myAccount.errorPhone")'
              :sub-text='$t("myAccount.phoneNumberMessage")'
              :placeholder='$t("address.placeholderPhone")'
              :maxlength="32"
              inputType="tel"
              name="phone"
              id="input_phone"
              v-model="addressData.phone"
          />

          <input-text
              v-if="isPhoneNumberRequired"
              class="col-12 mb-3"
              :title='$t("myAccount.phoneNumber")'
              :data="v$.addressData.phone"
              :error-text='$t("myAccount.errorPhone")'
              :sub-text='$t("myAccount.phoneNumberMessage")'
              :placeholder='$t("address.placeholderPhone")'
              :maxlength="32"
              inputType="tel"
              name="phone"
              id="input_phone"
              @keyup.enter.prevent="submitForm()"
              v-model="addressData.phone"
          />

          <input-text
              v-if="currentType === TYPE_CHECKOUT"
              class="col-12 mb-3"
              :maxlength="64"
              :title='$t("myAccount.email")'
              :data="v$.addressData.email"
              :error-text='$t("myAccount.errorEmail")'
              name="email"
              input-type="email"
              id="input_email"
              v-model="addressData.email"
          />

          <input-text
              v-if="currentType === TYPE_CHECKOUT"
              class="col-12 mb-3 pssword"
              :title='$t("myAccount.password")'
              :sub-text="$t('checkout.passwordMessage')"
              :data="v$.addressData.password"
              :error-text='$t("myAccount.errorPassword")'
              :maxlength="32"
              input-type="password"
              name="passwd"
              id="passwd"
              @keyup.enter.prevent="submitForm()"
              v-model="addressData.password"
          />

          <div v-show="errorBag.length" class="col-12 mt-3 text--sm">
            <i class="fas fa-times-circle text-danger mr-2"></i>
            <span class="text-danger font-weight-bold">{{ $t("myAccount.errorMessage") }}</span>

            <div v-for="error in errorBag" id="opc_login_errors">
              <div v-if="error.name && error.type" class="text-danger ml-4" v-text="'- '+ getValidationError(error.name, error.type)"></div>
              <div v-else class="text-danger ml-4" v-text="'- ' + error.error"></div>
            </div>
          </div>
          <div class="text-danger text--sm" id="opc_account_errors">

          </div>

          <div class="col-12 d-flex align-items-center py-4" v-if="currentType === TYPE_ACCOUNT">
            <label class="toggle-switch mr-2">
              <input
                  class="toggle-switch--input"
                  v-model="addressData.default_address"
                  :checked="addressData.default_address"
                  type="checkbox"
              >
              <span class="toggle-switch--slider round"></span>
            </label>
            <div class="text--green">{{ $t("myAccount.defaultAddress") }}</div>
          </div>

        </div>
      </div>
    </div>

    <div class="py-4 account__card--bottom-bar align-items-center" v-if="currentType === TYPE_ACCOUNT ">
      <button class="button button--clear m-0" @click="cancelCheck()">{{ $t("myAccount.cancel") }}</button>
      <button
          class="button-brekz button-brekz--rounded button-brekz--xl m-0"
          :class="{'button-brekz--green': !isSubmitting || !errorBag.length}"
          @click="submitForm()"
      >
        <img
            v-if="isSubmitting"
            class="mx-auto"
            style="height: 25px;"
            src="/themes/brekz-2017/img/loading-indicator-l.gif"
        >
        <div v-else>{{ $t("myAccount.save") }}</div>
      </button>
    </div>
      <div class="py-4 account__card--bottom-bar align-items-center" v-if="isCheckoutAddress">
          <div class="button button--clear m-0" @click="jsGetBack">{{ $t("myAccount.cancel") }}</div>
          <button type="submit" @click="checkValidate" class="button button--yellow button--large m-0 d-flex justify-content-center">
                <span>
                 {{ $t("myAccount.save") }}
                <i class="icon-chevron-right right"></i>
                </span>
          </button>

          <input type="hidden" name="shopping_cart_address_form" value="true">
          <button style="display: none; visibility: hidden; opacity: 0.000001" name="submitAddress" id="submitAddress"></button>
      </div>

    <div class="py-4 account__card--bottom-bar align-items-center" v-if="currentType === TYPE_CHECKOUT">
      <button class="button button--clear m-0" @click="jsGetBack">{{ $t("myAccount.cancel") }}</button>
      <button
          type="submit"
          class="d-flex button button--large button--icon-right checkoutButton mx-0 d-flex justify-content-center"
          style="min-width: 120px;"
          :class="{'button--yellow': !errorBag.length}"
          id="submitAccount"
          name="submitAccount"
          @click="checkValidate"
          value=""
      >
        {{ $t("myAccount.save") }}
        <i class="fa fa-chevron-right mb-auto mt-auto" style="font-size: 14px;"></i>
      </button>

      <button style="display: none; visibility: hidden; opacity: 0.000001" id="submitAccount"></button>
    </div>

    <modal-vue
        type="confirm"
        :show="showCancelWarning"
        @confirm="cancelEdit()"
        @cancel="closeModal()"
        title="Verwijderen"
        width="xs"
        :buttons="addressCreateCancelButtons"
    >
      <p class="my-4">{{ $t("myAccount.eraseWarning") }}<br/><br/>{{ $t("myAccount.eraseConfirmation") }}</p>
    </modal-vue>
  </div>
</template>

<script>
import ModalVue from "./ModalVue";
import InputText from "./Address/InputText";
import validationRules from '../js/validation/rules';
import getError from '../js/validation/getError';
import useVuelidate from "@vuelidate/core";
import { required, email, maxLength, minLength, requiredIf } from '@vuelidate/validators'

const ID_COUNTRY_GERMANY     = 1;
const ID_COUNTRY_AUSTRIA     = 2;
const ID_COUNTRY_BELGIUM     = 3;
const ID_COUNTRY_FRANCE      = 8;
const ID_COUNTRY_ITALY       = 10;
const ID_COUNTRY_LUXEMBOURG  = 12;
const ID_COUNTRY_NETHERLANDS = 13;
const ID_COUNTRY_SWEDEN      = 18;
const ID_COUNTRY_SWITZERLAND = 19;
const ID_COUNTRY_DENMARK     = 20;

const addressTwoField = [
  ID_COUNTRY_NETHERLANDS,
  ID_COUNTRY_GERMANY,
  ID_COUNTRY_AUSTRIA,
  ID_COUNTRY_SWITZERLAND,
  ID_COUNTRY_FRANCE,
  ID_COUNTRY_ITALY,
  ID_COUNTRY_BELGIUM,
  ID_COUNTRY_DENMARK,
  ID_COUNTRY_SWEDEN,
];

export const TYPE_ACCOUNT = 'account'
export const TYPE_CHECKOUT = 'checkout'
export const TYPE_CHECKOUT_ADDRESS = 'checkout-address'

export const CustomValues = {
  checkout: {
    title: 'checkout.newAccount',
  },
  account: {
    title: 'myAccount.addAddress'
  },
  'checkout-address': {
    title: 'myAccount.addAddress'
  }
};

export default {
  name: "AddressCreate",
  props: {
    phpErrors: {
        type: Array,
        required: false,
        default: []
    },
    countries: Array,
    defaultCountryId: Number,
    addressCopyData: Object,
    currentType: String,
    getAddressLink: {
        required: false,
        type: String,
    },
    backLink: {
        required: false,
        type: String,
    },
    isGuest: {
        required: true,
        type: Boolean,
    }
  },
  components: {
    ModalVue,
    InputText
  },
  setup () {
        return { v$: useVuelidate() }
  },
  data() {
    return {
      addressData: {
        first_name: '',
        last_name: '',
        address: '',
        house_number: '',
        address2: '',
        postcode: '',
        city: '',
        id_country: this.defaultCountryId,
        phone: '',
        default_address: false,
        password: '',
        email: '',
      },
      TYPE_ACCOUNT: TYPE_ACCOUNT,
      TYPE_CHECKOUT: TYPE_CHECKOUT,
      TYPE_CHECKOUT_ADDRESS: TYPE_CHECKOUT_ADDRESS,
      countriesData: {
        ID_COUNTRY_GERMANY: ID_COUNTRY_GERMANY,
        ID_COUNTRY_AUSTRIA: ID_COUNTRY_AUSTRIA,
        ID_COUNTRY_BELGIUM: ID_COUNTRY_BELGIUM,
        ID_COUNTRY_FRANCE: ID_COUNTRY_FRANCE,
        ID_COUNTRY_ITALY: ID_COUNTRY_ITALY,
        ID_COUNTRY_LUXEMBOURG: ID_COUNTRY_LUXEMBOURG,
        ID_COUNTRY_NETHERLANDS: ID_COUNTRY_NETHERLANDS,
        ID_COUNTRY_DENMARK: ID_COUNTRY_DENMARK,
        ID_COUNTRY_SWITZERLAND: ID_COUNTRY_SWITZERLAND,
        ID_COUNTRY_SWEDEN: ID_COUNTRY_SWEDEN,
      },
      addressTwoField: addressTwoField,
      CustomValues: CustomValues,
      showCancelWarning: false,
      isSubmitting: false,
      addressCreateCancelButtons: [
        {
          text: this.$t('myAccount.cancel'),
          class: "",
          emit_name: "cancel"
        },
        {
          text: this.$t('myAccount.delete'),
          class: "button--extra-large button-brekz button-brekz--rounded button-brekz--yellow",
          emit_name: "confirm"
        }
      ]
    };
  },
  validations() {
      return {
          addressData: {
              first_name: {
                  required,
                  maxlength: maxLength(32),
              },
              last_name: {
                  required,
                  maxlength: maxLength(32),
              },
              address: {
                  required,
                  validateAddress: validationRules.address,
                  maxlength: maxLength(32),
              },
              house_number: {
                  required: requiredIf(function (){
                      return this.addressData.id_country !== this.countriesData.ID_COUNTRY_FRANCE
                  }),
                  maxlength: maxLength(5),
                  validateHouseNumber: validationRules.houseNumber,
              },
              address2: {
                  maxlength: maxLength(128),
              },
              postcode: {
                  required,
                  validateZipCode: validationRules.zipCode
              },
              city: {
                  required,
                  validateCity: validationRules.city
              },
              phone: {
                  required: requiredIf(function () {
                      return this.isPhoneNumberRequired
                  }),
                  validatePhone: validationRules.phone
              },
              email: {
                  required: requiredIf(function (nestedModel) {
                      return this.currentType === this.TYPE_CHECKOUT
                  }),
                  email,
              },
              password: {
                  required: requiredIf(function (nestedModel) {
                      return this.currentType === this.TYPE_CHECKOUT && (!this.isGuest)
                  }),
                  minlength: minLength(5),
              }
          }
      }
  },
    computed: {
        errorBag() {
            if (! this.v$.addressData) {
                return [];
            }

            return this.v$
                       .addressData
                       .$errors
                       .map((error) => ({
                           name: error.$property,
                           type: error.$validator,
                           error: error.$message
                       }))
                       .concat(this.phpErrors.map((message) => ({
                           error: message
                       })));
        },
        passesValidation() {
            return (
                this.errorBag.length === 0
            );
        },
        isCheckoutAddress() {
            return this.currentType === this.TYPE_CHECKOUT_ADDRESS;
        },
        isPhoneNumberRequired() {
            return false;
        }
    },
  methods: {
    jsGetBack(event) {
        event.preventDefault();
        event.stopPropagation();

        if (this.backLink) {
            window.location.href = this.backLink;
            return true;
        }

        window.history.back();
        return true;
    },
    getValidationError(name, type) {
      return getError(name, type);
    },
    checkValidate(event){
      event.preventDefault();
      this.v$.$touch();

      if (this.v$.$invalid) {
        return;
      }

      this.isSubmitting = true;

      if(this.isGuest){
        document.getElementById('submitGuestAccount').click();
        return;
      }

      if (this.currentType === this.TYPE_CHECKOUT_ADDRESS){
        document.getElementById('submitAddress').click();
        return;
      }

      if (this.currentType === this.TYPE_CHECKOUT) {
        document.getElementById('submitAccount').click();
        return;
      }

      document.getElementById('submitAccount').click();

    },
    submitForm() {
      this.v$.$touch();

      if (this.v$.$invalid) {
        return;
      }

      this.isSubmitting = true;

      if (this.isCheckoutAddress){
          document.getElementById('submitAddress').click();
      }

      if (this.currentType === this.TYPE_CHECKOUT) {
          document.getElementById('submitAccount').click();
          return;
      }

      this.addressData.postcode = this.addressData.postcode.replace(' ', '');

      jQuery.ajax(`${this.getAddressLink}?action=create`, {
        type: "POST",
        data: JSON.stringify(this.addressData),
        success: response => {
          if (this.addressData.default_address === true) {
            this.$emit('default-address-changed', {
              id_address: response.address.id_address,
              changed_to: this.addressData.default_address
            });
          }
          this.$emit('new-address-data', { addressData: this.addressData });

          if (this.backLink){
              window.location.href = this.backLink
          }

          this.isSubmitting = false;
          this.closeEditCollapse();
        },
        error: XMLHttpRequest => {
          this.$emit('error-occurred');
          console.log('Create address failed', XMLHttpRequest.responseText);
          this.isSubmitting = false;
        }
      });


    },
    closeEditCollapse() {
      this.$emit('close');
    },
    cancelEdit() {
      document.body.classList.remove("modal-vue--open");
      this.showCancelWarning = false;
      this.clearFormData();
      this.closeEditCollapse();
    },
    closeModal() {
      this.showCancelWarning = false;
      this.closeEditCollapse();
      document.body.classList.remove("modal-vue--open");

    },
    checkCountry() {
      if ($('#input_country_addressCreate').val() === '13') {
        $('#input_zipcode_addressCreate').attr('placeholder', '1234AB').focus().blur();
      }
      if ($('#input_country_addressCreate').val() === '3') {
        $('#input_zipcode_addressCreate').attr('placeholder', '1234').focus().blur();
      }

    },
    cancelCheck() {
      if ($('[id^="input_"]').val() === '') {
        this.closeEditCollapse();
        document.body.classList.remove("modal-vue--open");
          if (this.backLink) {
                window.location.href = this.backLink
          }
      } else {
        this.showCancelWarning = true;
        document.body.classList.add("modal-vue--open");
      }
    },
    clearFormData() {
      this.addressData = {
        firstname: '',
        last_name: '',
        address: '',
        house_number: '',
        address2: '',
        postcode: '',
        city: '',
        id_country: this.defaultCountryId,
        phone: '',
        default_address: false
      };

      this.$emit('clear-address-copy-data');
    },
    removeSpaces() {
        this.addressData.postcode = this.addressData.postcode.replace(' ', '');
    }
  },
  watch: {
    addressCopyData: function(val) {
      if (val !== {}) {
        this.addressData = val;
      }
    },
  }
};
</script>
